export function getConfig(host?: string) {
    const hostName = host || window.location.hostname;
    const hostArr = hostName.split(".");
    const domain = hostArr.slice(hostArr.length - 2).join(".");
    if (domain === "ksyun.com") {
        return {
            domain: "ksyun.com",
            baseHost: "console.ksyun.com"
        };
    } else {
        return {
            domain: "kingsoft-cloud.com",
            baseHost: "console.kingsoft-cloud.com"
        };
    }
}

export const releaseConfig = getConfig();
